$(document).ready(function (e) {
    $('.slide .play').click(function (e) {
        e.preventDefault();
        $('#home_embed').css('visibility', 'visible');
        $('.slide a.play').css('visibility', 'hidden');
    })
    $(document).on('click touchstart', '#menu-mobile-toggle', function (e) {
        toggleMobileMenu();
    });

    scopeHeight($('.slide'));

    if ($('.mini-movie').length) {
        scopeHeight($('.mini-movie'));
        $('.mini-movie').click(function (a) {
            location.href = $(this).find('a').attr('href');
        })
    }

    if ($('.movie-trailer').length) {
        var height = $('.movie-trailer').width() / 2.35;
        $('.movie-trailer iframe').css('height', height + 35);
    }

    resizeIframes();
    setTimeout(function(){ resizeContentToFooterBottom(); }, 500);
    checkCookieNotice();

    $('#close_cookie_notice').on('click', null, function (e) {
        closeCookieNotice();
    });

});

function checkCookieNotice() {
    if (!localStorage.getItem('cookieNoticeClose')) {
        $('#cookie_notice').show(0);
    }
}
function closeCookieNotice() {
    localStorage.setItem('cookieNoticeClose', 'true');
    $('#cookie_notice').hide(0);
}

function toggleMobileMenu() {
    if ($('#menu-mobile').hasClass('menu-open')) {
        $('#menu-mobile').animate({"margin-right": '-100%'});
        $('#menu-mobile').removeClass('menu-open');
    }
    else {
        $('#menu-mobile').animate({"margin-right": '0px'});
        $('#menu-mobile').addClass('menu-open')
    }
}

$( window ).resize(function() {
    scopeHeight($('.mini-movie'));
    resizeIframes();
    resizeContentToFooterBottom();
})

function resizeIframes() {
    if ($('iframe').not('iframe.no-resize').length) {
        $.each($('iframe'), function (index, obj) {
            $(obj).css('width', '100%');
            console.log('resize iframes ' + $(obj).width());
            //$(obj).css('height',Math.round($(obj).width()/2.35))
            $(obj).css({'width': '100%', 'height': Math.round($(obj).width() / 2.35)});
        });
    }
}

function scopeHeight(obj) {
    if (obj.length) {
        var height = $(obj).width() / 2.35;
        $(obj).css('height', height)
        if ($(".menu-mobile").is(":visible")) {
            $('#movies .credit').css('position', 'static');
        } else {
            $('#movies .ads-movie').css('height', height);
        }
        $('#movies .credit').show();
    }
}

function resizeContentToFooterBottom(){
    var $section = $('section');
    $section.css('min-height', 'auto');
    var windowH = window.innerHeight;
    var footerTop = $('footer').offset().top;
    var footerHeight = $('footer').height();

    if(windowH > footerTop){
        var sectionHeight = $section.innerHeight();
        var newSectionHeight = windowH - (footerHeight); //(sectionHeight + (windowH - footerTop)) - footerHeight;
        $section.css('min-height', newSectionHeight);
    }
};